'use client'

import { useBackgroundMode } from './BackgroundSwitcher'
import { AnimatedGradient } from './AnimatedGradient'

export function BackgroundManager() {
  const mode = useBackgroundMode()
  const showGradient = mode === 'gradient' || mode === 'both'

  if (!showGradient) return null
  return (
    <div style={{ opacity: mode === 'both' ? 0.3 : 1 }}>
      <AnimatedGradient />
    </div>
  )
}
